import {makeStyles} from "@material-ui/core";

export default makeStyles((theme) => ({
  riskProfileCard: {
    borderRadius: 16,
    border: '1px solid #B5BBC2',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 270,
    }
  },
  riskProfileCardTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    '&.product-selection': {
      textTransform: 'uppercase',
      lineHeight: '1em',
      width: 100,
    }
  },
  riskInfoBox: {
    textAlign: 'center',
    borderRadius: 8,
    background: 'rgba(131,138,147,0.12)',
    '& .category': {
      fontFamily: 'Roboto-Bold',
      fontSize: 18,
    }
  },
}))